import FoodDetails from "./foodDetails";
import CommonWeightsAndMeasures from "./commonWeightsAndMeasures";
import servingsType from "./servingsType";
import NutrientData from "./nutrientData";

export const foodItemSteps = [
	{
		id: "foodDetails",
		title: "Food Details",
		component: FoodDetails
	},
	// {
	// 	id: "servingsType",
	// 	title: "Servings Type",
	// 	component: servingsType,
	// },
	{
		id: "nutrientData",
		title: "Nutrient Data",
		component: NutrientData
	},
	{
		id: "commonWeightsAndMeasures",
		title: "Common Weights And Measures",
		component: CommonWeightsAndMeasures
	}
];
